import useApiClient from './api-client'
import type { GetSearchKeywordsParams, GetSearchSuggestionKeywordsParams } from '@/types/search'
import type { FsearchSuggestionsResV2Data } from '@/types/api'

/**
 * * for Popular search keywords
 */
export const getSearchKeywords = async (params: GetSearchKeywordsParams) => {
  const api = useApiClient<{ list: string[] }>()
  const result = await api(`/search/keywords`, { query: params })

  return result
}

/**
 * * for suggestion auto complete search
 */
export const getSearchSuggestions = async (params: GetSearchSuggestionKeywordsParams) => {
  const api = useApiClient<FsearchSuggestionsResV2Data>()
  const result = await api(`/search/suggestions`, { query: params })

  return result
}
